// extracted by mini-css-extract-plugin
export default {"container":"titleWithBeta_container__QBLwK"};